import React, {useEffect, useState} from 'react';
import CustomDataTable from "../CustomDataTable";
import ReactDOM from "react-dom";
import {trans} from "../../utils";

const Finish = ({params,data}) =>{

    const columns = [
        {data : 'id' , title: '#'},
        {data :"created_on",title:"Date"},
        {data :"delivered_to.name",title:"Delivered to"},
        {data :"failure_types",title:"Failure types"}
    ];
    const columnDefs = [
        {
            targets: -1,
            orderable: false,
            className: "all",
            width: "285px",
            createdCell: (td, cellData, full) => ReactDOM.render(
                <>
                    {cellData.map(data => (
                        <p>{trans(data.title)}</p>
                    ))}
                </>
                , td)

        }
    ];
    return(
       <>
            <div className="card-header cursor-pointer">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">{trans('Finish Comments')}</h3>
                </div>
            </div>
            <div className="card-body p-9">
                <CustomDataTable columns={columns} columnDefs={columnDefs} url={"getWorkOrderFinish?wo_id="+params.id} table_id="reopen" />
            </div>
        </>
    )

}
export default Finish
